import { render, staticRenderFns } from "./succession-file-actions.vue?vue&type=template&id=e6f6125e&scoped=true&"
import script from "./succession-file-actions.vue?vue&type=script&lang=js&"
export * from "./succession-file-actions.vue?vue&type=script&lang=js&"
import style0 from "./succession-file-actions.vue?vue&type=style&index=0&id=e6f6125e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6f6125e",
  null
  
)

export default component.exports